import { inject, Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable, tap } from 'rxjs'
import { EnvironmentsConfigsInterface } from '@environments/core/interfaces/environments-configs.interface'
import { environment } from '@environments/environment'
import { EnvironmentsHelperService } from '@environments/core/services/environments-helper.service'

@Injectable({
	providedIn: 'root',
})
export class EnvironmentsService {
	protected readonly date: DateConstructor = Date

	private readonly _http: HttpClient = inject(HttpClient)
	private readonly _environmentsHelperService: EnvironmentsHelperService = inject(EnvironmentsHelperService)

	public getEnvironmentsConfigs(): Observable<EnvironmentsConfigsInterface> {
		const params: HttpParams = new HttpParams().append('_', this.date.now())

		return this._http.get<EnvironmentsConfigsInterface>(environment.environmentsConfigsUrl, { params }).pipe(
			tap((response: EnvironmentsConfigsInterface): void => {
				this._environmentsHelperService.environmentsConfigs$.next(response)
			}),
		)
	}
}
